import { connect } from 'react-redux';
import LoadingSpinner from '../components/LoadingSpinner';
export default connect(function (state) { return ({
    backgroundColour: state.project.config.backgroundColour,
}); })(LoadingSpinner);
